import React from "react";
import ImageHeader from "./../../components/common/image-header";
import EnhancedContentSection from "./../../components/common/enhanced-content-section";
import ButtonFx from "./../../components/common/button-fx";
import { useHistory } from "react-router-dom";
import PageTagging from "components/common/page-tagging/page-tagging";
import FeatureBar from "./feature-bar";
import OurEquipment from "./our-equipment";
import NationwideCoverage from "./nationwide-coverage";
import ClientSection from "./client-section";

const Home = () => {
  let history = useHistory();
  return (
    <>
      <ImageHeader
        imgSrc={`/images/mr-traffic-hero.jpg`}
        mobileImgSrc="/images/mr-traffic-hero-mobile.jpg"
      />
      <PageTagging
        title="Mr Traffic Hire | Specialised Traffic Equipment Hire Melbourne"
        description="Mr Traffic Hire provide a wide range of specialised traffic equipment hire products across Victoria. VMS Boards, Arrow Boards, Truck Mounted Attenuators and more"
      />
      <FeatureBar />
      <OurEquipment />
      <NationwideCoverage />
      <ClientSection />
      {/* <Citiwest /> */}
      {/* <EnhancedContentSection isBlocking={false} showPageTitle={true}>
        <h2>About Us</h2>

        <div className="mt-4 text-justify">
          <p>
            Mr Traffic Hire (Australia) provides traffic management equipment
            hire for projects of every size across Australia. From roadworks and
            major infrastructure to events and advertising, we deliver reliable
            equipment backed by exceptional service.
          </p>
          <p>
            Available 24/7, we're committed to providing safe, dependable, and
            cost-effective solutions that keep your projects moving.
          </p>

          <ButtonFx
            onClick={() => history.push("/about/")}
            className="mt-blue-mini-button"
          >
            Learn More
          </ButtonFx>
        </div>
      </EnhancedContentSection> */}

      {/* <Partner /> */}
    </>
  );
};

export default Home;
